var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.size, _vm.theme],attrs:{"id":"icon-more-option"}},[_c('i',{staticClass:"el-icon-more"})])
}
var staticRenderFns = []

export { render, staticRenderFns }